import {Entity} from '@s-ui/domain'

export class WalletEntity extends Entity {
  /**
   * @constructor
   * @param {String} id
   * @param {String} userId
   * @param {String} iban
   * @param {Number} amount
   * @param {String} thirdPartyId
   * @param {String} provider
   */
}
